
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index2gvNNtL2UPMeta } from "/Users/shichengyi/private/github/letter-to-pabo/pages/index.vue?macro=true";
import { default as testAQ1pYV6CLQMeta } from "/Users/shichengyi/private/github/letter-to-pabo/pages/test.vue?macro=true";
import { default as thankyoudLwCis9ISfMeta } from "/Users/shichengyi/private/github/letter-to-pabo/pages/thankyou.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Users/shichengyi/private/github/letter-to-pabo/pages/index.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/Users/shichengyi/private/github/letter-to-pabo/pages/test.vue")
  },
  {
    name: "thankyou",
    path: "/thankyou",
    component: () => import("/Users/shichengyi/private/github/letter-to-pabo/pages/thankyou.vue")
  }
]